<template>
  <LayoutDefault>
    <section class="teachers">
      <h1 class="teachers__title">Руководство. Педагогический (научно-педагогический) состав</h1>
      <div class="teachers__block"
        v-for="(item, idx) in test"
        :key="idx"
      >
        <Textarea
          v-model="item.description"
          autoResize rows="1"
          cols="70"
        />
      </div>
      <div class="teachers__table">
        <TeachersTable :data="dataSource"/>
      </div>
      <div class="teachers__button">
        <BaseBtn
          blue
          plus
          text="Добавить"
          @click="openAddTeacherModal"
        />
      </div>
      <BaseModalWindow
        @closeModal="closeAddTeacherModal"
        v-if="addTeacherModal"
        title="Добавление"
      >
      <AddTeacherModal />
      </BaseModalWindow>
    </section>
  </LayoutDefault>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import LayoutDefault from '@/layout/LayoutDefault'
import TeachersTable from '@/components/blocks/TeachersTable.vue'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import AddTeacherModal from '@/components/modals/AddTeacherModal.vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'TeachersView',
  components: {
    LayoutDefault,
    TeachersTable,
    BaseBtn,
    BaseModalWindow,
    AddTeacherModal,
    Textarea
  },
  props: {
  },
  setup () {
    const store = useStore()

    const test = ref([
      {
        id: 1,
        name: '',
        description: 'а) о руководителе образовательной организации, в том числе: фамилия, имя, отчество (при наличии); наименование должности; контактные телефоны; адрес электронной почты.'
      },
      {
        id: 2,
        name: '',
        description: 'б) о заместителях руководителя образовательной организации (при наличии), в том числе: Заместитель руководителя в образовательной организации отсутствует.'
      },
      {
        id: 3,
        name: '',
        description: 'в) о руководителях филиалов, представительств образовательной организации (при наличии), в том числе: фамилия, имя, отчество (при наличии); наименование должности; контактные телефоны; адрес электронной почты. Филиалы у образовательной организации отсутствуют.'
      }
    ])

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    const addTeacherModal = computed(() => store.getters.getShowAddTeacherModal)

    const openAddTeacherModal = (val) => {
      store.commit('SetShowAddTeacherModal', val)
    }

    const closeAddTeacherModal = (val) => {
      store.commit('SetShowAddTeacherModal', false)
    }

    return {
      test,
      dataSource,
      addTeacherModal,
      openAddTeacherModal,
      closeAddTeacherModal
    }
  }
}
</script>

<style lang="scss" scoped>
.teachers {
  &__title {
    @include information-block-title;
    margin-bottom: 32px;
  }

  &__block {
    display: flex;
    margin-bottom: 16px;
  }

  &__table {
    margin-bottom: 24px;
  }

  &__button {
    display: flex;
    justify-content: flex-end;

    :deep(.blue-button) {
      display: flex;
      align-items: center;
      gap: 13px;
      padding: 12px 16px;
    }
  }

  :deep(.modal__header) {
    border: none;
  }
}
</style>
